export const TEMPLATE_PICKER_LABEL = 'Apply Comment Template';

export const TEMPLATE_PICKER_PLACEHOLDER = 'Select a comment template';
